import { render, staticRenderFns } from "./FileUploadPreview.vue?vue&type=template&id=18e18735&scoped=true"
import script from "./FileUploadPreview.vue?vue&type=script&lang=ts"
export * from "./FileUploadPreview.vue?vue&type=script&lang=ts"
import style0 from "./FileUploadPreview.vue?vue&type=style&index=0&id=18e18735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e18735",
  null
  
)

export default component.exports